import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaChevronRight } from 'react-icons/fa';
import { Page, PageHeader, Card, SearchInput, EmptyRow, Alert, Loading, initials, formatDate } from '../../ui';
import { formatAddress } from '../../ui/JobParts';
import { api } from '../../ui/api';

const Users = () => {
  const [users, setUsers] = useState(null);
  const [error, setError] = useState('');
  const [query, setQuery] = useState('');

  useEffect(() => {
    api('/user/users').then((d) => setUsers(d.users || [])).catch((e) => { setError(e.message); setUsers([]); });
  }, []);

  const q = query.toLowerCase();
  const rows = (users || []).filter((u) =>
    (u.username || '').toLowerCase().includes(q) || (u.email || '').toLowerCase().includes(q) || (u.phone_number || '').includes(query));

  return (
    <Page>
      <PageHeader title="Customers" subtitle="Everyone who has signed up in the customer app." />
      <Alert>{error}</Alert>
      <Card flush>
        <div className="toolbar">
          <SearchInput value={query} onChange={setQuery} placeholder="Search by name, email or phone" />
          {users && <span className="count">{rows.length} of {users.length}</span>}
        </div>
        {!users ? <Loading /> : (
          <div className="table-wrap">
            <table className="table stack-sm">
              <thead>
                <tr><th>Customer</th><th>Phone</th><th>Primary address</th><th>Joined</th><th /></tr>
              </thead>
              <tbody>
                {rows.length ? rows.map((user) => {
                  const primary = (user.addresses || []).find((a) => a.is_primary) || (user.addresses || [])[0];
                  return (
                    <tr key={user.id}>
                      <td data-label="Customer">
                        <div className="row" style={{ flexWrap: 'nowrap' }}>
                          <div className="avatar">{initials(user.username)}</div>
                          <div style={{ minWidth: 0 }}>
                            <Link to={`/manage-users/user/${user.id}`} className="strong">{user.username}</Link>
                            <span className="sub">{user.email}</span>
                          </div>
                        </div>
                      </td>
                      <td data-label="Phone" className="nowrap">{user.phone_number}</td>
                      <td data-label="Primary address" style={{ maxWidth: 320 }}>
                        {primary ? <span className="muted">{formatAddress(primary)}</span> : <span className="muted">No address saved</span>}
                      </td>
                      <td data-label="Joined" className="nowrap">{formatDate(user.created_at)}</td>
                      <td className="actions-cell"><Link className="icon-btn" to={`/manage-users/user/${user.id}`}><FaChevronRight /></Link></td>
                    </tr>
                  );
                }) : <EmptyRow cols={5}>{query ? 'No customers match your search.' : 'No customers yet.'}</EmptyRow>}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </Page>
  );
};

export default Users;
